var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6373 2.06762C10.0275 1.67674 10.6603 1.67645 11.0509 2.06697L12.4615 3.47759C12.852 3.86812 12.8523 4.50157 12.4621 4.89246L7.10446 10.2601C6.969 10.3958 6.79742 10.4896 6.61015 10.5305L4.80943 10.9232C4.09864 11.0782 3.46576 10.4456 3.61974 9.73391L4.00997 7.93043C4.05056 7.74283 4.14421 7.57088 4.27975 7.43509L9.6373 2.06762Z",
    stroke: "#1271A6",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22656 3.76318L11.0514 6.58802",
    stroke: "#1271A6",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 14.2783H12.7937",
    stroke: "#1271A6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d0862d73963fa6b6821335a18f8148e7.svg";
export { ForwardRef as ReactComponent };